export function getPercentDisplayValue(value: string): string | undefined {
  const numValue = Number.parseFloat(value);

  return Number.isNaN(numValue) ? undefined : `${numValue.toFixed(2)}%`;
}
